import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";

export default function LoginPage() {
  const { login } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      nav("/account");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="login-page">
      <h1 className="font-display font-black text-5xl tracking-tighter mb-8">{t.auth.login}</h1>
      <form onSubmit={submit} className="space-y-4">
        <input required type="email" className="vt-input" placeholder={t.auth.email} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
        <input required type="password" className="vt-input" placeholder={t.auth.password} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
        {error && <div className="text-red-600 text-sm" data-testid="login-error">{error}</div>}
        <button disabled={loading} className="vt-btn-orange w-full" data-testid="login-submit">{loading ? "..." : t.auth.login}</button>
      </form>
      <div className="mt-4 text-right">
        <Link to="/forgot-password" className="text-xs link-underline text-neutral-600" data-testid="forgot-password-link">Forgot password?</Link>
      </div>
      <p className="mt-6 text-sm text-neutral-500">
        {t.auth.noAccount} <Link to="/register" className="link-underline text-black font-bold">{t.auth.register}</Link>
      </p>
    </div>
  );
}
